module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-conseil-experts-masque-carotte.533bad93.jpg";